/* RAGANA Interactions JS v1.1 — sans curseur custom */
(function () {
  'use strict';

  /* ============================================================
     1. RIPPLE AU CLIC
  ============================================================ */
  document.addEventListener('click', e => {
    const target = e.target.closest(
      '.rg-btn, .rg-pdp__atc, .rg-btn-outline, .rg-card__quick-add, .rg-hero-cta-primary, .rg-col-card, .rg-qty__btn'
    );
    if (!target) return;
    target.style.position = target.style.position || 'relative';
    target.style.overflow = 'hidden';
    const rect = target.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height) * 1.6;
    const x = e.clientX - rect.left - size / 2;
    const y = e.clientY - rect.top  - size / 2;
    const rip = document.createElement('span');
    rip.className = 'rg-ripple';
    Object.assign(rip.style, {
      width: size + 'px', height: size + 'px',
      left: x + 'px',    top:  y + 'px',
    });
    target.appendChild(rip);
    rip.addEventListener('animationend', () => rip.remove(), { once: true });
  });

  /* ============================================================
     2. BOUTONS MAGNÉTIQUES
  ============================================================ */
  const isTouchDevice = () => window.matchMedia('(hover: none)').matches;

  if (!isTouchDevice()) {
    document.querySelectorAll('.rg-pdp__atc').forEach(btn => {
      btn.addEventListener('mousemove', e => {
        const rect = btn.getBoundingClientRect();
        const cx = rect.left + rect.width  / 2;
        const cy = rect.top  + rect.height / 2;
        const dx = (e.clientX - cx) * .28;
        const dy = (e.clientY - cy) * .28;
        btn.style.transform = `translate(${dx}px, ${dy}px) translateY(-3px)`;
      });
      btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
    });
  }

  /* ============================================================
     3. TILT 3D SUR LES CARTES PRODUIT
  ============================================================ */
  if (!isTouchDevice()) {
    const TILT_SEL = '.rg-card, .rg-col-card';
    const TILT_AMOUNT = 6;

    function applyTilt(el, e) {
      const rect = el.getBoundingClientRect();
      const cx = rect.left + rect.width  / 2;
      const cy = rect.top  + rect.height / 2;
      const rx =  ((e.clientY - cy) / (rect.height / 2)) * TILT_AMOUNT;
      const ry = -((e.clientX - cx) / (rect.width  / 2)) * TILT_AMOUNT;
      el.style.transform = `perspective(800px) rotateX(${rx}deg) rotateY(${ry}deg) translateY(-4px) scale(1.01)`;
    }

    document.addEventListener('mousemove', e => {
      document.querySelectorAll(TILT_SEL).forEach(el => {
        const rect = el.getBoundingClientRect();
        const inEl = e.clientX >= rect.left && e.clientX <= rect.right &&
                     e.clientY >= rect.top  && e.clientY <= rect.bottom;
        if (inEl) applyTilt(el, e);
        else el.style.transform = '';
      });
    }, { passive: true });

    document.querySelectorAll(TILT_SEL).forEach(el => {
      el.addEventListener('mouseleave', () => {
        el.style.transition = 'transform .5s cubic-bezier(.25,.46,.45,.94)';
        el.style.transform = '';
        setTimeout(() => el.style.transition = '', 500);
      });
    });
  }

  /* ============================================================
     4. PARALLAXE HERO AU SCROLL
  ============================================================ */
  const heroBg = document.querySelector('.rg-hero-bg-img');
  if (heroBg) {
    window.addEventListener('scroll', () => {
      const y = window.scrollY;
      const heroH = heroBg.closest('.rg-hero')?.offsetHeight || window.innerHeight;
      if (y < heroH) {
        heroBg.style.transform = `scale(1.04) translateY(${y * .28}px)`;
      }
    }, { passive: true });
  }

  /* ============================================================
     5. PARTICULES AU CLIC SUR BOUTON ATC
  ============================================================ */
  document.addEventListener('click', e => {
    const atc = e.target.closest('.rg-pdp__atc, .rg-card__quick-add');
    if (!atc) return;
    const rect = atc.getBoundingClientRect();
    const cx = rect.left + rect.width  / 2;
    const cy = rect.top  + rect.height / 2;
    for (let i = 0; i < 10; i++) {
      const p = document.createElement('div');
      p.className = 'rg-particle';
      const size  = Math.random() * 5 + 3;
      const angle = (i / 10) * Math.PI * 2;
      const dist  = Math.random() * 60 + 30;
      const dur   = Math.random() * .4 + .5;
      Object.assign(p.style, {
        width:  size + 'px', height: size + 'px',
        left:   cx + 'px',  top:    cy + 'px',
        '--dx': (Math.cos(angle) * dist) + 'px',
        '--dy': (Math.sin(angle) * dist - 20) + 'px',
        '--dur': dur + 's',
      });
      document.body.appendChild(p);
      setTimeout(() => p.remove(), dur * 1000 + 100);
    }
  });

  /* ============================================================
     6. SCROLL-REVEAL STAGGERÉ
  ============================================================ */
  const revealIO = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('rg-revealed');
        revealIO.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.rg-product-grid > *, .rg-col-grid > *, .rg-features-grid > *').forEach((el, i) => {
    if (!el.classList.contains('rg-reveal')) {
      el.classList.add('rg-reveal', `rg-stagger-${(i % 6) + 1}`);
      revealIO.observe(el);
    }
  });

  /* ============================================================
     7. COMPTEURS ANIMÉS
  ============================================================ */
  const COUNTER_RE = /^\d+([.,]\d+)?/;
  function animateCounter(el) {
    const raw   = el.textContent.trim();
    const match = COUNTER_RE.exec(raw);
    if (!match) return;
    const num    = parseFloat(match[0].replace(',', '.'));
    const suffix = raw.slice(match[0].length);
    const dur    = 1200;
    const start  = performance.now();
    function step(now) {
      const p    = Math.min((now - start) / dur, 1);
      const ease = 1 - Math.pow(1 - p, 3);
      const cur  = num % 1 === 0 ? Math.round(num * ease) : (num * ease).toFixed(1);
      el.textContent = cur + suffix;
      if (p < 1) requestAnimationFrame(step);
      else el.textContent = raw;
    }
    requestAnimationFrame(step);
  }
  const counterIO = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) { animateCounter(e.target); counterIO.unobserve(e.target); }
    });
  }, { threshold: .5 });
  document.querySelectorAll('.hero-stat-val').forEach(el => counterIO.observe(el));

  /* ============================================================
     8. GLOW SUR LES CARTES COLLECTION
  ============================================================ */
  document.querySelectorAll('.rg-col-card').forEach(card => {
    card.addEventListener('mousemove', e => {
      const rect = card.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width  * 100).toFixed(1);
      const y = ((e.clientY - rect.top)  / rect.height * 100).toFixed(1);
      card.style.background = `radial-gradient(circle at ${x}% ${y}%, rgba(193,154,107,.12) 0%, transparent 60%)`;
    });
    card.addEventListener('mouseleave', () => { card.style.background = ''; });
  });

  /* ============================================================
     9. SCROLL PROGRESS BAR
  ============================================================ */
  const bar = document.createElement('div');
  Object.assign(bar.style, {
    position: 'fixed', top: '0', left: '0',
    height: '2px', width: '0%',
    background: 'var(--c-accent, #C19A6B)',
    zIndex: '99999', transition: 'width .1s linear',
    pointerEvents: 'none', borderRadius: '0 2px 2px 0',
  });
  document.body.appendChild(bar);
  window.addEventListener('scroll', () => {
    const pct = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
    bar.style.width = Math.min(pct, 100) + '%';
  }, { passive: true });

  /* ============================================================
     10. SMOOTH ANCHOR SCROLL
  ============================================================ */
  document.querySelectorAll('a[href^="/#"]').forEach(a => {
    a.addEventListener('click', e => {
      const id = a.getAttribute('href').slice(2);
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  /* ============================================================
     11. IMAGE LAZY LOAD AVEC FONDU
  ============================================================ */
  document.querySelectorAll('img[loading="lazy"]').forEach(img => {
    img.style.opacity = '0';
    img.style.transition = 'opacity .5s ease';
    if (img.complete) img.style.opacity = '1';
    else img.addEventListener('load', () => { img.style.opacity = '1'; });
  });

  /* ============================================================
     12. VIBRATION HAPTIC MOBILE
  ============================================================ */
  if ('vibrate' in navigator) {
    document.querySelectorAll('.rg-pdp__atc, .rg-card__quick-add').forEach(btn => {
      btn.addEventListener('click', () => navigator.vibrate(8));
    });
  }

}());